<template>
    <div class="animated fadeIn">
        <div class="card card-green">
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-12">
                        <label class="custom-label mr-1">{{$t('STARTDATE')}}</label>
                        <lb-vue-datetimepicker
                            type="date"
                            v-model="startDate"
                            :translate-method="translateDateTimePicker"
                            format="YYYY-MM-DD"
                            display-format="DD.MM.YYYY"
                            :simple="true">
                        </lb-vue-datetimepicker>
                        <label class="custom-label mr-1">{{$t('ENDDATE')}}</label>
                        <lb-vue-datetimepicker
                            type="date"
                            v-model="endDate"
                            :translate-method="translateDateTimePicker"
                            format="YYYY-MM-DD"
                            display-format="DD.MM.YYYY"
                            :simple="true">
                        </lb-vue-datetimepicker>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12  table-responsive">
                        <table class="table table-bordered table-striped table-hover table-sm table-logoped">
                            <thead>
                            <tr>
                                <th>
                                    {{$t('EVENTCNT')}}
                                </th>
                                <th>{{$t('NAME')}}</th>
                                <th>{{$t('SURNAME')}}</th>
                                <th>{{$t('VISITQUOTAPERWEEK')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for="item in response.root">
                                <tr :key="item.userId" aria-rowindex="1" class=" table-ellipsis">
                                    <td>{{item.cnt}}</td>
                                    <td>{{item.name}}</td>
                                    <td>{{item.surname}}</td>
                                    <td>{{item.visitQuota}}</td>
                                </tr>
                            </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from '@/api/statistics/Statistics';

export default
{
    name: 'Statistics',
    data()
    {
        return {
            startDate: null,
            endDate: null,
            response:
                {},
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
        {
            translateDateTimePicker(val)
            {
                const me = this;
                return me.$t(val.toUpperCase());
            },
            async getData()
            {
                const me = this;
                try
                {
                    const data = await Api.getEventStatistics(me.getParams);
                    if (data.error && data.error === true)
                    {
                        me.$notify.notice(data);
                        me.loading = false;
                        return;
                    }

                    me.response = data;
                }
                catch (e)
                {
                    me.$notify.notice(e);
                }
            },
        },
    watch:
        {
            'startDate'()
            {
                const me = this;
                me.getData();
            },
            'endDate'()
            {
                const me = this;
                me.getData();
            },
        },
    computed:
        {
            getParams()
            {
                const me = this;
                const data = {};

                if (me.startDate != null)
                {
                    data.startDate = me.startDate;
                }

                if (me.endDate != null)
                {
                    data.endDate = me.endDate;
                }
                return data;
            },
        },
};
</script>
